import isServer from '@anm/helpers/is/isServer';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { OpenEditorProps } from '..';
import vtConfig from '../../../config';
import routes from '../../../routes';
import { authSelectors } from '../../../store/modules/auth';

const { Router } = routes;

const { urls } = vtConfig();

const getSignUpUrl = (redirectUrl?: string) => {
  const { asPath } = Router;
  const defaultRedirectUrl = `${urls.wave}${asPath!.replace('/', '')}`;
  const redirectUrlParam = encodeURIComponent(redirectUrl || defaultRedirectUrl);

  return `${urls.wave}signup?redirectUrl=${redirectUrlParam}`;
};

type useUrlProps = Pick<OpenEditorProps, 'isAuthControl'> & { editorUrl: string };

const useUrl = ({ editorUrl, isAuthControl }: useUrlProps) => {
  const isLoggedIn = useSelector(authSelectors.selectAuthLoginStatus);
  const getUrl = () => (isServer() ? '' : !isAuthControl || isLoggedIn ? editorUrl : getSignUpUrl(editorUrl));
  const [url, setUrl] = useState(getUrl());

  useEffect(() => {
    setUrl(getUrl());
  }, [getUrl()]);

  return url;
};

export default useUrl;
